var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-head-container" }, [
    _c("div", { staticClass: "page-head clearfix" }, [
      _c(
        "div",
        { staticClass: "page-head-info columns clearfix" },
        [
          _vm.hasHeaderTopSlot
            ? _c(
                "div",
                { staticClass: "page-head-extra-top" },
                [_vm._t("header-top")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shouldNavBack && !_vm.hasHeaderTopSlot,
                  expression: "shouldNavBack && !hasHeaderTopSlot",
                },
              ],
              staticClass: "nav-bar",
            },
            [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      return _vm.navBack()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          < " +
                      _vm._s(_vm.$i18n.t("back")) +
                      "\n        "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "page-head-project-info clearfix" }, [
            _c("div", { staticClass: "page-project__number" }, [
              _vm._v("\n          # " + _vm._s(_vm.number) + "\n        "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row page-project__name" }, [
              _c(
                "div",
                [_vm._v(_vm._s(_vm.description)), _vm._t("options")],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("Lifecycle", {
            ref: "projectLifecycle",
            attrs: {
              type: "project",
              showCommentCol: false,
              histories: _vm.currentProjectHistory,
              emptyHistoryHint: _vm.emptyProjectLifecycle,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "status-actions clearfix" },
            [
              _vm._t("status", function () {
                return [
                  _vm.status
                    ? _c(
                        "div",
                        {
                          staticClass: "status float-left",
                          class: _vm.statusStyle,
                          on: {
                            click: function ($event) {
                              return _vm.openLifecycleModal()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.status) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actions clearfix" },
                [_vm._t("buttons")],
                2
              ),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }